module.exports = __webpack_public_path__ + "media/images/testimonial1-c607d62160cbc07d5d865dc68672bb04.png";